import { useCallback, useEffect, useState } from "react";
import Toast from "./Cards/Toast";
import {
  RATE_LIMIT_EVENT,
  RATE_LIMIT_MESSAGE,
} from "../helper/rateLimitHandler";

export default function RateLimitToast() {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    const handleRateLimit = (event) => {
      setNotifications([
        {
          id: `rate-limit-${Date.now()}`,
          message: event.detail?.message || RATE_LIMIT_MESSAGE,
          tone: "danger",
        },
      ]);
    };

    window.addEventListener(RATE_LIMIT_EVENT, handleRateLimit);
    return () => window.removeEventListener(RATE_LIMIT_EVENT, handleRateLimit);
  }, []);

  const handleDismiss = useCallback((notificationId) => {
    setNotifications((current) =>
      current.filter((notification) => notification.id !== notificationId),
    );
  }, []);

  return (
    <Toast
      notifications={notifications}
      onDismiss={handleDismiss}
      closeLabel="بستن"
      defaultDuration={6000}
    />
  );
}
